<template>
  <div class="about">
    <h1>关于我们</h1>
    <div class="about-content">
      <h2>我们的使命</h2>
      <p>我们致力于为用户提供高质量的教授信息搜索服务，帮助用户快速找到所需的教授资料。</p>
      <h2>我们的团队</h2>
      <p>我们由一群热爱教育和技术的专业人士组成，不断努力提升产品的功能和用户体验。</p>
      <h2>发展历程</h2>
      <ul>
        <el-timeline style="max-width: 600px">

          <el-timeline-item timestamp="2025/6/20" placement="top">
            <el-card>
              <h4>新增留言墙</h4>
              <p>2025/6/20</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2025/5/20" placement="top">
            <el-card>
              <h4>网站上线</h4>
              <p>2025/5/20</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  name: 'About',
}
</script>

<style scoped>
.about {
  text-align: center;
  padding: 20px;
}

.about-content {
  text-align: left;
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  margin-top: 30px;
  margin-bottom: 10px;
}

p {
  line-height: 1.6;
}

ul {
  list-style-type: disc;
  padding-left: 20px;
}
</style>